export const getDayMonthYear = (date = new Date()) => ({
  day: date.getUTCDate().toString(),
  month: (date.getUTCMonth() + 1).toString(),
  year: date.getUTCFullYear().toString(),
});
